<tr class="recipient-chooser-tr">
  <td class='td-vertical-align recipient-col-fix'>
    <pt-widget-select
      (changeValue)='changeSelectedRecipientEntity($event)'
      *ngIf="!loading"
      [items]='recipientEntityList'
      [selectedValue]='currentRecipientEntity'
      [width]="'100%'">
    </pt-widget-select>
  </td>

  <td class='td-vertical-align'>
    <ul class='list-unstyled m-0'>
      <ng-container *ngFor='let item of recipientType; let i = index'>
        <li>
          <div class='form-check'>
            <input (change)='clickRecipientType(item.uuid)'
                   [checked]='item.uuid === internalValue?.recipientType'
                   [value]='item.uuid'
                   class='form-check-input'
                   id='{{id}}_recipientType_{{i}}'
                   type='radio'>
            <label class='form-check-label d-flex align-items-baseline'
                   for='{{id}}_recipientType_{{i}}'>
              {{ item.label }}
              <pt-w-help [help]='item?.help'></pt-w-help>
            </label>
          </div>
        </li>
      </ng-container>
    </ul>
  </td>

  <td class='td-vertical-align'>
    <div class="d-flex align-items-center">
      <div class='form-check d-flex  align-items-center'>
        <input (change)='clickExtraUe()'
               [checked]='internalValue?.extraUe'
               [value]='internalValue?.extraUe'
               class='form-check-input'
               type='checkbox'>
      </div>
<!--      [isRequired]="internalValue?.extraUe"-->

      <pt-widget-select
        (changeValue)='changeSelectedCountry($event)'
        [disabled]='!internalValue?.extraUe'
        [items]='countryList'
        [selectedValue]='currentCountry'
        [width]="'160px'"
        class="d-inline-flex">
      </pt-widget-select>

    </div>
  </td>

  <td class="td-vertical-align">
    <ul class='list-unstyled m-0'>
      <ng-container *ngFor='let item of guarantees; let i = index'>
        <li>
          <div class='form-check d-flex align-items-start'>
            <input (change)='clickGuarantees(item.uuid)'
                   [checked]='isGuaranteesChecked(item.uuid)'
                   [disabled]='!internalValue?.extraUe'
                   [class.is-invalid]='guaranteesRequired && internalValue.extraUe && internalValue.guarantees?.length === 0'
                   class='form-check-input'
                   id='{{id}}_guarantees_{{i}}'
                   type='checkbox'>
            <label class='form-check-label d-flex ms-1'
                   for='{{id}}_guarantees_{{i}}'>
              {{ item.label }}
            </label>
          </div>
        </li>
      </ng-container>
    </ul>
  </td>

  <td>
    <div
      (click)='openTextAreaPurpose(internalValue?.purpose)'
      [ngStyle]="{
                'height': purposeHeight,
                '-webkit-line-clamp': guarantees?.length ? guarantees?.length : 1}"
      class='rc-textarea'>
      {{ internalValue?.purpose }}
    </div>
  </td>

  <td class='p-0 text-center'>
    <button (click)='clickDelete.emit()'
            class='btn btn-sm btn-danger'
            style="padding: 3px; margin-top: 3px;"
            ngbTooltip="{{ 'BUTTON.DELETE' | translate}}">
      <pt-icon [key]='IconDelete'></pt-icon>
    </button>
  </td>
</tr>
